import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { BButton, BCol, BRow, BText, BTitle } from '@prague-digi/ui-components'

import { SmsVerifyError } from '../../constants'
import smsCrossed from '../../assets/sms_cross.svg'
import { variants } from './errorVariants'
import { appActions } from '../../redux'

type ReduxProps = ConnectedProps<typeof connector>

type OuterProps = {
  nextAttemptAvailable?: boolean
  sendSms: Function
  translate: Function
  variant: SmsVerifyError
}

type Props = ReduxProps & OuterProps

export const SmsError: React.FC<Props> = ({
  nextAttemptAvailable,
  resetApplication,
  sendSms,
  translate,
  variant,
}: Props) => {
  const errorVariant = variants[variant]
  const action = variant === SmsVerifyError.Ko ? resetApplication : sendSms
  const isActionButtonVisible = variant === SmsVerifyError.Ko || nextAttemptAvailable

  return (
    <div data-test-id="verify-sms-error">
      <BRow>
        <BCol theme="text-center">
          <img alt="" src={smsCrossed} />
        </BCol>
      </BRow>
      <BTitle center type="h3" theme="mt-4">
        {translate(errorVariant.title)}
      </BTitle>
      <BRow>
        <BCol theme="text-center">
          <BText>{translate(errorVariant.text)}</BText>
        </BCol>
      </BRow>
      {isActionButtonVisible && (
        <BRow data-test-id="verify-sms-error-action-button">
          <BCol theme="text-center">
            <BButton
              messages={{ message: translate(errorVariant.btn) }}
              type="button"
              color="primary"
              size="lg"
              onClick={action}
              tabIndex={0}
              theme="w-50"
            />
          </BCol>
        </BRow>
      )}
    </div>
  )
}

const connector = connect(null, {
  resetApplication: appActions.resetApplication,
})

export default connector(SmsError)
